// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { createShipTo, updateShipTo as updateShipToApi } from "@insite/client-framework/Services/CustomersService";
import loadShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTo";
import {
    AddOrUpdateShipTo,
    chain,
    DispatchCompleteUpdateShipTo,
    DispatchSetLastSelectedShipTo,
    DispatchShipTosResetDataViews,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateShipTo";

// XNG-Changes: FLIP-892 This handler being used to handle Create Ship to errors
// The OOTB is close the modal after the user click save, but this is a customization to keep 
// the modal open until it success, otherwise will stay open and show error

export const xAddOrUpdateShipTo: typeof AddOrUpdateShipTo = async (props: any) => {
    try {
        if (props.parameter.shipTo.isNew) {
            props.apiResult = await createShipTo({
                shipTo: props.parameter.shipTo,
            });
        } else {
            props.apiResult = await updateShipToApi({
                billToId: props.parameter.billToId,
                shipTo: props.parameter.shipTo,
            });
        }
        props.error = "";
    } catch (error) {
        props.error = (error as any)?.errorMessage;
    }
    if (props.error) {
        return;
    }
    // reload to make sure we get validation
    await makeHandlerChainAwaitable(loadShipTo)({
        billToId: props.parameter.billToId,
        shipToId: props.apiResult.id,
    })(props.dispatch, props.getState);
};

export const excuteOnError = (props: any) => {
    if (props.error) {
        props.parameter.onError(props.error);
    }
};

export const xDispatchCompleteUpdateShipTo = (props: any) => {
    if (props.error) {
        return;
    }
    DispatchCompleteUpdateShipTo(props);
};
export const xDispatchSetLastSelectedShipTo = (props: any) => {
    if (props.error) {
        return;
    }
    DispatchSetLastSelectedShipTo(props);
};
export const xExecuteOnSuccessCallback = (props: any) => {
    if (props.error) {
        return;
    }
    ExecuteOnSuccessCallback(props);
};

export const xDispatchShipTosResetDataViews: typeof DispatchShipTosResetDataViews = (props: any) => {
    if (props.error) {
        return;
    }
    // We call onSuccess just to close the modal when create/edit address
    // done successfully. I know its not the best way but to avoid doing a lot of customization
    // on many files
    props.parameter.onSuccess?.(true,true);
    
    DispatchShipTosResetDataViews(props);
};
replaceInChain(chain, AddOrUpdateShipTo, xAddOrUpdateShipTo);
addToChainBefore(chain, DispatchCompleteUpdateShipTo, excuteOnError);
replaceInChain(chain, DispatchCompleteUpdateShipTo, xDispatchCompleteUpdateShipTo);
replaceInChain(chain, DispatchSetLastSelectedShipTo, xDispatchSetLastSelectedShipTo);
replaceInChain(chain, ExecuteOnSuccessCallback, xExecuteOnSuccessCallback);
replaceInChain(chain, DispatchShipTosResetDataViews, xDispatchShipTosResetDataViews);
